module.exports = __webpack_public_path__ + "img/group-icon.d0c26aac.png";